/**
 * Tableau de bord administrateur (CDC §17) : indicateurs filtrables par territoire et période, analyses et fil
 * d'activité du jour. Une vue sur plusieurs territoires l'indique toujours explicitement (`scope.label`) et détaille
 * chaque territoire.
 */
export interface DashboardKpis {
  dossiersCreated: number;
  salesCount: number;
  salesHtCents: number;
  /** chiffre d'affaires opérationnel : total TTC des bons de commande signés sur la période */
  signedTtcCents: number;
  installationsDone: number;
  maintenancesDone: number;
  paymentsCollectedCents: number;
  paymentsToRemitCents: number;
  toControl: number;
  interventionsToAccept: number;
  interventionsRefused: number;
  savOpened: number;
  savOpen: number;
  stockLow: number;
}

export interface DashboardBreakdownRow {
  key: string;
  label: string;
  count: number;
  amountCents?: number;
  extra?: string;
}

export interface DashboardActivity {
  at: string;
  kind: 'control' | 'intervention' | 'sav' | 'payment' | 'sale';
  tone: 'success' | 'warning' | 'danger' | 'info' | 'neutral';
  text: string;
  dossierId: string | null;
}

export interface Dashboard {
  from: string;
  to: string;
  scope: { territoryIds: string[]; label: string; multiple: boolean };
  kpis: DashboardKpis;
  /** one line per territory when several are shown (never mixed without saying so) */
  byTerritory: (DashboardKpis & { territoryId: string; name: string })[];
  salesByCommercial: DashboardBreakdownRow[];
  topProducts: DashboardBreakdownRow[];
  topBrands: DashboardBreakdownRow[];
  topPowers: DashboardBreakdownRow[];
  installsByTechnician: (DashboardBreakdownRow & { savCount: number; savRate: number | null })[];
  commissions: { kind: string; label: string; toValidateCents: number; validatedCents: number; paidCents: number }[];
  activity: DashboardActivity[];
}

/** Period shortcuts of the filter. */
export function periodPreset(preset: 'today' | '7d' | 'month' | 'last_month' | 'year', today: string): { from: string; to: string } {
  const d = new Date(`${today}T12:00:00Z`);
  const iso = (x: Date) => x.toISOString().slice(0, 10);
  switch (preset) {
    case 'today':
      return { from: today, to: today };
    case '7d':
      return { from: iso(new Date(d.getTime() - 6 * 86_400_000)), to: today };
    case 'month':
      return { from: `${today.slice(0, 7)}-01`, to: today };
    case 'last_month': {
      const first = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() - 1, 1));
      const last = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 0));
      return { from: iso(first), to: iso(last) };
    }
    case 'year':
      return { from: `${today.slice(0, 4)}-01-01`, to: today };
  }
}
